import { bool, func, shape, string } from 'prop-types';
import React from 'react';

import { getTooltipButtonWithText } from '../../generic/Tooltip';
import HELP_TEXTS from '../../opportunities/help-texts';
import { opportunityShape } from '../../prop-types';
import api from '../../REST/api';
import withResolved from '../../REST/with-resolved';
import ProjectEntity from '../ProjectEntity';
import { ProjectEntityPropTypes } from '../ProjectEntity/ProjectEntity';
import ProjectInvoiceForm from './ProjectInvoiceForm.container';

const ButtonWithTooltip = getTooltipButtonWithText(HELP_TEXTS);

class ProjectInvoice extends React.Component {
  renderTitle = () => <h4>Invoices</h4>;

  render() {
    const { entityProps, isExpandable, model } = this.props;
    const isInvoicingDisabled = !model.primaryQuote;
    const { isEditing } = entityProps;

    return (
      <ProjectEntity
        title={this.renderTitle()}
        {...entityProps}
        onSave={this.props.entityProps.onSave}
        onCancel={this.props.entityProps.onCancel}
        isExpandable={isExpandable}
      >
        <ProjectInvoiceForm
          opportunity={model}
          tag={ButtonWithTooltip}
          additionalButtonProps={{
            helpKey: 'invoicingIsMissingPrimaryQuote',
            section: 'navigation',
            showTooltip: isInvoicingDisabled,
          }}
          isEditing={isEditing}
        />
      </ProjectEntity>
    );
  }
}

ProjectInvoice.propTypes = {
  model: opportunityShape.isRequired,
  opportunityId: string.isRequired,
  onChange: func.isRequired,
  onSubmit: func.isRequired,
  entityProps: shape(ProjectEntityPropTypes).isRequired,
  isExpandable: bool.isRequired,
};

export default withResolved({
  query: api.getOpportunity,
  deriveQueryArgs: props => ({ id: props.opportunityId }),
  as: 'model',
})(ProjectInvoice);
